import * as searchGetters from './store/searchStore-getters'
import * as searchSetters from './store/searchStore-setters'
import * as autocompleteSetters from './store/autocompleteStore-setters'
import * as filtersSetters from './store/filters-setters'
import * as dateFiltersSetters from './store/date-filters-setters'
// get default data from config file
import configData from '../../config'

const loadResults = () => {
  // load new results
  searchSetters.loadSearchResults()
}

const loadResultsWithDataPreload = () => {
  // load new results
  searchSetters.loadSearchResultsWithDataPreload()
}

const loadResultsWithDataPreloadAlt = () => {
  // load new results
  searchSetters.loadSearchResultsWithDataPreloadAlt()
}

const newSearchQuery = (params) => {
  autocompleteSetters.setIsActiveAutocompleteDropdown(true)
  // set new search params
  searchSetters.setSearchParams(params)
  resetPageParams()

  // init search
  loadResultsWithDataPreload()
}

const resetSearchQuery = () => {
  resetPageParams()
  // init search
  loadResultsWithDataPreload()
}

const resetPageParams = () => {
  // set number of items per page to default
  searchSetters.resetRows()
  // set page start to default
  searchSetters.resetPageStart()

  // set sorting to default
  if (searchGetters.searchParams().key == configData().params.search.default.key) {
    searchSetters.setNewSorting(configData().params.search.default.sortOptionAll)
  } else {
    searchSetters.resetSorting()
  }

  // resets filters
  filtersSetters.resetFilterParams()
  // resets date filters
  dateFiltersSetters.resetDateRange()
}

const loadDateRanges = () => {
  // load new date ranges
  searchSetters.loadDateRanges()
}

export {
  loadResults,
  newSearchQuery,
  loadResultsWithDataPreload,
  loadResultsWithDataPreloadAlt,
  loadDateRanges,
  resetSearchQuery
}



// WEBPACK FOOTER //
// ./src/scripts/modules/search.js